import { render, staticRenderFns } from "./arrows-right-outlined.vue?vue&type=template&id=f964931c&scoped=true&"
var script = {}
import style0 from "./arrows-right-outlined.vue?vue&type=style&index=0&id=f964931c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f964931c",
  null
  
)

export default component.exports